import type { Meta, StoryObj } from "@storybook/react";

import { RecurrenceValue } from "@/constants/Schedule";
import type { AppointmentOverviewHeaderProps } from "@/ui/components/schedule/booking/AppointmentOverviewHeader";
import AppointmentOverviewHeader from "@/ui/components/schedule/booking/AppointmentOverviewHeader";
import type { EventDetailsLinesProps } from "@/ui/components/schedule/details/EventDetailsLines";
import { Box } from "@/ui/layout";

const StoryMeta: Meta<AppointmentOverviewHeaderProps> = {
  title: "Components/Schedule/Booking/Appointment Overview Header",
  component: AppointmentOverviewHeader,
  argTypes: {
    appointmentTitle: { control: "text" },
    attendeeCount: { control: "number" },
    recurrence: {
      control: "select",
      options: Object.values(RecurrenceValue),
    },
    testID: { control: "text" },
  },
  args: {
    appointmentTitle: "Therapy Session",
    attendeeCount: 3,
    recurrence: "Weekly",
    testID: "storybook-appointment-overview-header",
    timeRange: {
      endTime: "2024-09-03T09:30:00",
      startTime: "2024-09-03T09:00:00",
    } as BookingTimeRange,
  },
  render: (args) => (
    <Box width="100%">
      <AppointmentOverviewHeader {...args} />
    </Box>
  ),
};

type Story = StoryObj<EventDetailsLinesProps>;

export const Primary: Story = {};
export default StoryMeta;
